import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
);

// Load web vitals only in development to reduce production bundle size
if (process.env.NODE_ENV === 'development') {
    import('./reportWebVitals').then(({ default: reportWebVitals }) => {
        reportWebVitals();
    });
}
